export enum TipoGrupoEscopoEnum {
    Territoriais = 1,
    Produto = 2,
    Servico = 3,
    Fornecedor = 4,
    Cliente = 5
}
